<ng-container *ngrxLet="patientDashboardData$ as patientDashboardData">
  <ng-container *ngIf="isFlaggedPatientToggled; else recentPatients">
    <div class="tile-head flex-row flex-vertical-center">
      <cigna-icon class="dashboard-icon" type="friends"></cigna-icon>
      <h3 class="cg-h3">
        {{ 'dashboard.patients' | translate }} |
        {{ 'dashboard.flagged' | translate }}
      </h3>
      <div style="margin-left: auto">
        <button cignaButton="link small" (click)="toggle()">
          {{ 'dashboard.recent' | translate }}
        </button>
        <span class="toggle-pipe">|</span>
        <span class="link-small-selected">
          {{ 'dashboard.flagged' | translate }}
        </span>
      </div>
    </div>

    <cigna-patient-detail-list
      [isEditable]="isEditable"
      [isRestrictedImpersonator]="isRestrictedImpersonator"
      [patients]="patientDashboardData?.data?.flaggedPatients"
      [isLoading]="patientDashboardData?.loading"
      [flaggedKeys]="patientDashboardData?.data.flaggedIds"
      [isFlagTile]="true"
      (flag)="updateFlaggedPatients($event)"
    >
    </cigna-patient-detail-list>
  </ng-container>

  <ng-template #recentPatients>
    <div class="tile-head flex-row flex-vertical-center">
      <cigna-icon class="dashboard-icon" type="friends"></cigna-icon>
      <h3 class="cg-h3">
        {{ 'dashboard.patients' | translate }} |
        {{ 'dashboard.recent' | translate }}
      </h3>
      <div style="margin-left: auto">
        <span class="link-small-selected">
          {{ 'dashboard.recent' | translate }}
        </span>
        <span class="toggle-pipe">|</span>
        <button cignaButton="link small" (click)="toggle()">
          {{ 'dashboard.flagged' | translate }}
        </button>
      </div>
    </div>

    <cigna-patient-detail-list
      [isEditable]="isEditable"
      [isRestrictedImpersonator]="isRestrictedImpersonator"
      [patients]="patientDashboardData?.data?.recentPatients"
      [isLoading]="patientDashboardData?.loading"
      [flaggedKeys]="patientDashboardData?.data.flaggedIds"
      [isFlagTile]="false"
      (flag)="updateFlaggedPatients($event)"
    >
    </cigna-patient-detail-list>
  </ng-template>
</ng-container>
